module.exports = __webpack_public_path__ + "static/media/latidoLogo.87153d7d.png";